<template>
    <div class="playPage" v-wechat-title="this.title">
        <div class="video">
            <div class="bofang" v-show="showB == '1'">
                <img :src="cover" alt="" class="cover">
                <img src="../../assets/play.png" alt="" class="play">
            </div>
            <div id='id_test_video' style="width:100%;height:auto"></div>
        </div>
        <toast :msg="msg" ></toast>
    </div>
</template>
<script>
    import cbct from '../../../static/js/base.js'
    import toast from '../commen/toast.vue'
    import { Loadmore } from 'mint-ui'; 
    import qs from 'qs';
    import share from '../../../static/js/share.js';
    export default {
        name: 'playPage',
        props: {
            
        },
        data(){
            return { 
                msg:'',
                playUrl:'',
                cover:'',
                title:'话题',
                player1:'',
                showB:'1',
                created:'',
                timer1:'',
                timer2:'',
                autoPlay:false,
            }
        },
        created(){
            var self=this;
            if(this.$route.query.playUrl){
                this.playUrl=decodeURIComponent(this.$route.query.playUrl);
            }
            if(this.$route.query.cover){
                this.cover=decodeURIComponent(this.$route.query.cover);
            }
            share.share(this,window.location.href,'可听、可看、可聊的广播里，主持人在等你来撩~','听见广播，看见美好声音','https://seefm.oss-cn-beijing.aliyuncs.com/image/share_pic_topic.jpg','可听、可看、可聊的广播里，主持人在等你来撩~');
            share.QQshare(window.location.href,'可听、可看、可聊的广播里，主持人在等你来撩~','听见广播，看见美好声音','https://seefm.oss-cn-beijing.aliyuncs.com/image/share_pic_topic.jpg');
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if(isIOS){
                self.autoPlay = true;
            }else{
                self.autoPlay = false;
            }
            
        },
        mounted(){
            var self = this;
            this.player1 = new TcPlayer('id_test_video', {
                "mp4": self.playUrl,
                autoplay : self.autoPlay,      //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                poster:'',
                systemFullscreen:true,
                "wording": {
                    2032: "请求视频失败，请检查网络",
                    2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                },
                'controls':'none',
                h5_flv:true,
                flash:true,
                live:true,
                x5_player:true,
                x5_orientation:2,
                listener:function(msg){
                    if(self.player1.playing() == true){
                        self.showB = '';
                    } 
                    var u = navigator.userAgent, app = navigator.appVersion;
                    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    if (isIOS) {
                        
                        // if(self.player1.playing() == false){  
                            wx.getNetworkType({                        
                                success: function (res) {
                                    
                                    $('video')[0].play();
                                }
                            });
                        // }
                    }
                    $('video').css('object-fit','fill');
                    if(msg.type == 'load'){
                        self.created = '1';
                        $('video').css('object-fit','fill');
                        
                        if(isAndroid){
                            $('video').attr("x5-video-player-type","h5-page");
                        }
                        // if (isIOS) {
                        //     document.addEventListener('WeixinJSBridgeReady',function(){  
                        //         $('video')[0].play();  
                        //     },false);
                        // }
                    }
                }
            });
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            var canplay = '0';
            this.timer1 = setInterval(function(){
                if(self.created == '1'){
                    canplay = '1';
                    clearInterval(self.timer1);
                }
            },50)
            
            $('.play').on('click',function(){
                var timer2 = setInterval(function(){
                    if(canplay == '1'){
                        clearInterval(timer2);
                        if(isAndroid){
                            $('video')[0].play();
                        }
                    }
                },50)
                
            })
            
            var md=document.getElementsByTagName("video")[0];
            md.addEventListener("ended",function(){
                window.history.go(-1);
            });
            
            // $('.play').click();
            
        },
        methods:{
            // play:function(){
            //     $('video')[0].play();
            // }
        },
        components: {
            toast,
        }
        
    }
</script>
<style scoped lang="scss">
    .playPage{
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        font-size: 0.24rem;
        .video{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            min-height: 100%;
            z-index: 3;
            .bofang{
                position: absolute;
                width: 100%;
                height: auto;
                z-index: 4;
                .cover{
                    width: 100%;
                    height: auto;
                }
                .play{
                    position: absolute;
                    top: 50%;
                    left: 3.35rem;
                    width: 1rem;
                    transform: translateY(-0.5rem);
                    z-index: 5;
                }
            }
            #id_test_video{
                position: absolute;
                top: 0;
                z-index: 3;
                width: 100%;
            }
        }
    }
</style>
